import DOMPurify from 'dompurify';

/**
 * Sanitize HTML content to prevent XSS attacks
 * @param {string} html - The HTML string to sanitize
 * @param {object} config - DOMPurify configuration options
 * @returns {string} - Sanitized HTML
 */
export const sanitizeHtml = (html, config = {}) => {
  const defaultConfig = {
    ALLOWED_TAGS: [
      'p',
      'br',
      'strong',
      'em',
      'u',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'ul',
      'ol',
      'li',
      'a',
      'img',
      'blockquote',
      'code',
      'pre',
      'span',
      'div',
    ],
    ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'class', 'id', 'target'],
    ALLOW_DATA_ATTR: false,
  };

  return DOMPurify.sanitize(html, { ...defaultConfig, ...config });
};

/**
 * Create a safe HTML object for React's dangerouslySetInnerHTML
 * @param {string} html - The HTML string to sanitize
 * @returns {object} - Object with __html property
 */
export const createSafeHtml = html => {
  return { __html: sanitizeHtml(html) };
};
